import React, { useEffect, useReducer, useState } from "react";

import AddTicketWithChannelPopup from "./sub-screen/AddTicketWithChannelPopup";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import { useCookies } from "react-cookie";

export const Context = React.createContext(null);

// Helper functions for date calculation
export const getToday = () => {
  const today = new Date();
  return today.toISOString().split("T")[0]; // Format: YYYY-MM-DD
};

export const getNext7Days = () => {
  const today = new Date();
  const next7Days = new Date(today);
  next7Days.setDate(today.getDate() + 7);
  return next7Days.toISOString().split("T")[0]; // Format: YYYY-MM-DD
};

const initialData = {
  filter: {
    region: "MN",
    channel: "",
    numbers: "",
    ticketCode: "",
    ticketType: "all",
    fromDate: getToday(), // Default: today
    toDate: getNext7Days(), // Default: 7 days from today
    page: 0,
  },
  filterPressCount: 0,
  isLoading: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SUBMIT_FILTER":
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.payload,
          page: 0,
        },
        filterPressCount: state.filterPressCount + 1,
      };
    case "UPDATE_PAGE":
      return {
        ...state,
        filter: {
          ...state.filter,
          page: action.payload,
        },
      };
    case "SET_REGION":
      return {
        ...state,
        filter: {
          ...state.filter,
          region: action.payload,
          channel: "",
          page: 0,
        },
        filterPressCount: state.filterPressCount + 1,
      };
    case "SET_LOADING":
      return {
        ...state,
        isLoading: Boolean(action.payload),
      };
    default:
      return {
        ...state,
      };
  }
};

const getRegionLabel = (region) => {
  if (region === "MN") return "Miền Nam";
  if (region === "MT") return "Miền Trung";
  if (region === "MB") return "Miền Bắc";
  return "";
};

export default ({ region: fixedRegion }) => {
  const [state, dispatch] = useReducer(reducer, initialData);
  const [showAddTicketPopup, setShowAddTicketPopup] = useState(false);

  const [cookies] = useCookies(["lottmekong"]);

  const selectedRegion = fixedRegion || state.filter.region || "MN";

  useEffect(() => {
    if (fixedRegion && state.filter.region !== fixedRegion) {
      dispatch({ type: "SET_REGION", payload: fixedRegion });
    }
  }, [fixedRegion, state.filter.region]);

  useEffect(() => {
    document.title = fixedRegion
      ? `Nhập vé ${getRegionLabel(selectedRegion)}`
      : "Nhập vé";
  }, [fixedRegion, selectedRegion]);

  return (
    <Context.Provider
      value={{
        state,
        dispatch,
      }}
    >
      <FilterForm
        region={selectedRegion}
        showRegionSelect={!fixedRegion}
        selectedRegion={selectedRegion}
        onRegionChange={(nextRegion) =>
          dispatch({ type: "SET_REGION", payload: nextRegion })
        }
        onAddTicket={() => setShowAddTicketPopup(true)}
      />

      <Table region={selectedRegion} cookie={cookies.lottmekong} />

      <AddTicketWithChannelPopup
        show={showAddTicketPopup}
        onHide={() => setShowAddTicketPopup(false)}
        region={selectedRegion}
        onRegionChange={(nextRegion) =>
          dispatch({ type: "SET_REGION", payload: nextRegion })
        }
        onSuccess={() => dispatch({ type: "SUBMIT_FILTER", payload: {} })}
      />
    </Context.Provider>
  );
};
